import { useNavigate } from 'react-router-dom';
import {
  AvailableDriversContainer,
  CardContainer,
  CardLeft,
  CardNameAndLogoContainer,
  CardNameText,
  CardRight,
  CardValueContainer,
  CardValueText,
  OpenButton,
  StarsContainer,
} from './styles';

export const AppHomeDomainCard = ({
  domain,
  estimatedCost,
  ratingAverage,
  drivers,
  logo,
  isFirstFetch,
  name,
  selectedUser,
  appTax,
  tripsWaitingDriver,
}) => {
  const navigate = useNavigate();
  const isPassenger = selectedUser === 'PASSENGER';
  return (
    <CardContainer>
      <CardLeft>
        <CardNameAndLogoContainer>
          <img src={logo || '/images/logo1.png'} alt="Icon" />
          <CardNameText>{name}</CardNameText>
        </CardNameAndLogoContainer>

        <StarsContainer>
          {Array.from({ length: ratingAverage }).map((_, index) => (
            <img key={index} src="/images/star.png" alt="star" />
          ))}
        </StarsContainer>

        <AvailableDriversContainer>
          {isPassenger ? 'Motoristas Online' : 'Viagens disponíveis'} -{' '}
          {isPassenger ? drivers.length : tripsWaitingDriver}
        </AvailableDriversContainer>
      </CardLeft>
      <CardRight>
        <CardValueContainer isFirstFetch={isPassenger ? isFirstFetch : false}>
          <CardValueText>
            {isPassenger ? (
              <>
                R$
                {estimatedCost.toLocaleString('pt-BR', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </>
            ) : (
              <>{parseFloat((appTax * 100).toFixed(2))}%</>
            )}
          </CardValueText>
        </CardValueContainer>
        <OpenButton
          onClick={() => {
            navigate(`/${domain}`);
            window.location.reload();
          }}
        >
          Abrir
        </OpenButton>
      </CardRight>
    </CardContainer>
  );
};
